import { useLoggedUserContext } from '../../AppContext';
import { Link } from 'react-router-dom';
import LoadingPopup from '../loading/LoadingPopup';
import { useMutation } from "@tanstack/react-query";
import ErrorPopup from "../error/ErrorPopup";
import { useNavigate } from "react-router-dom";
import userClient from '../../infrastructure/userClient';
import "./mainMenuPanel.css";

export default function MainMenuPanel() {
    const [loggedUser, setLoggedUser] = useLoggedUserContext();
    const navigate = useNavigate();

    const logOutQuery = useMutation({mutationFn: () => userClient.logOut()});
    if (logOutQuery.isSuccess) {
        setTimeout(() => {
            setLoggedUser(null);
            navigate('/login');
        });
    }

    return <>
        {logOutQuery.isError && <ErrorPopup message={logOutQuery.error.message}/>}
        {(logOutQuery.isPending || logOutQuery.isSuccess) ? <LoadingPopup/> : null}
        <div className='mainMenuPanel popup'>
            <div className="title"><img alt="Kingds and Emperors" src="logo.png"/> Kings and Emperors - <span className="">{loggedUser.login}</span></div>
            <div className="separator"/>
            <div className='content'>
                {/* <div>
                    <Link to="/single">
                        <button className='active'>Singleplayer tutorial</button>
                    </Link>
                </div> */}
                <div>
                    <Link to="/multi">
                        <button className='active'>Multiplayer games</button>
                    </Link>
                </div>
                {/* <div>
                    <Link to="/fame">
                        <button className='active'>Hall of fame</button>
                    </Link>
                </div> */}
                <div>
                    <a href={window.MAP_EDITOR_URL} target='_blank' rel="noreferrer">
                        <button className='active'>Map editor</button>
                    </a>
                </div>
                <div>
                    <button className='active' onClick={() => logOutQuery.mutate()}>Log out</button>
                </div>
            </div>
        </div>
    </>
}